import http from "./http";
import { AppDispatch, store } from "../Redux/store";
import { resetState } from "../Redux/actions/resetAction";

export async function clearExistingAuthSession(dispatch: AppDispatch) {
  const role = store.getState().user.role;
  const hasAccessToken = !!localStorage.getItem("sm-access-token");

  if (hasAccessToken) {
    try {
      if (role === "participant") {
        await http.post("/participant/auth/logout");
      } else {
        await http.post("/user/auth/logout");
      }
    } catch {
      // Still clear client session if logout fails
    }
  }

  localStorage.clear();
  dispatch(resetState());
}
